import { AuthApi } from '@linktivity/ars-neo';
import config from './config';

const authApi = new AuthApi(config);

export default authApi;
